"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWithEmoji = exports.TitleSpan = exports.Title = exports.Text = exports.Row = exports.PreformattedText = exports.List = exports.Label = exports.Hr = exports.FormGroup = exports.EmptyPage = exports.EmptyFlex = exports.Container = exports.Column = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Container = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding-left: ", ";\n  padding-bottom: 10px;\n  background-color: #000; /* For browsers that do not support gradients */\n  background: ", ";\n  ", "\n"])), function (_ref) {
  var noPadding = _ref.noPadding;
  return noPadding ? 0 : '54px';
}, function (_ref2) {
  var background = _ref2.background,
    noBackground = _ref2.noBackground;
  if (noBackground) {
    return 'none';
  }
  return background || '#000';
}, function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
});
exports.Container = Container;
var Row = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: ", ";\n  ", "\n"])), function (_ref4) {
  var center = _ref4.center,
    right = _ref4.right;
  if (center) {
    return 'center';
  }
  return right ? 'flex-end' : 'initial';
}, function (_ref5) {
  var $bsStyle = _ref5.$bsStyle;
  return $bsStyle || '';
});
exports.Row = Row;
var Column = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  padding-right: ", ";\n  ", "\n"])), function (_ref6) {
  var flex = _ref6.flex;
  return flex ? 1 : 'initial';
}, function (_ref7) {
  var left = _ref7.left,
    center = _ref7.center,
    right = _ref7.right;
  if (!left && !center && !right) {
    return 'initial';
  }
  if (center) {
    return 'center';
  }
  return right ? 'flex-end' : 'flex-start';
}, function (_ref8) {
  var centered = _ref8.centered;
  return centered ? 'center' : 'initial';
}, function (_ref9) {
  var right = _ref9.right;
  return right ? '20px' : 0;
}, function (_ref10) {
  var $bsStyle = _ref10.$bsStyle;
  return $bsStyle || '';
});
exports.Column = Column;
var EmptyPage = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  background-image: linear-gradient(\n    155.18deg,\n    rgb(29, 37, 38) -0.81%,\n    rgb(29, 37, 38) 16.33%,\n    rgb(0, 0, 0) 118.11%\n  );\n  ", "\n"])), function (_ref11) {
  var $bsStyle = _ref11.$bsStyle;
  return $bsStyle || '';
});
exports.EmptyPage = EmptyPage;
var FormGroup = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  ", "\n"])), function (_ref12) {
  var $bsStyle = _ref12.$bsStyle;
  return $bsStyle || '';
});
exports.FormGroup = FormGroup;
var Label = _styledComponents.default.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-top: 0;\n  margin-bottom: 1rem;\n  display: block;\n  margin-block-start: 1em;\n  margin-block-end: 1em;\n  margin-inline-start: 0;\n  margin-inline-end: 0;\n  color: ", ";\n  ", "\n"])), function (_ref13) {
  var color = _ref13.color;
  return color || '#000';
}, function (_ref14) {
  var $bsStyle = _ref14.$bsStyle;
  return $bsStyle || '';
});
exports.Label = Label;
var EmptyFlex = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  ", "\n"])), function (_ref15) {
  var $bsStyle = _ref15.$bsStyle;
  return $bsStyle || '';
});
exports.EmptyFlex = EmptyFlex;
var Hr = _styledComponents.default.hr(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: ", ";\n  border: none;\n  border-top: 1px solid #fff;\n  width: 100%;\n  ", "\n"])), function (_ref16) {
  var margin = _ref16.margin;
  return margin || '56px 10px 56px 0';
}, function (_ref17) {
  var $bsStyle = _ref17.$bsStyle;
  return $bsStyle || '';
});
exports.Hr = Hr;
var Text = _styledComponents.default.p(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: white;\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  padding-right: 5px;\n  font-weight: 500;\n  font-family: 'Gentleman', Arial, sans-serif;\n  @media screen and (max-width: 420px) {\n    font-size: 15px;\n  }\n  ", "\n"])), function (_ref18) {
  var $bsStyle = _ref18.$bsStyle;
  return $bsStyle || '';
});
exports.Text = Text;
var PreformattedText = _styledComponents.default.pre(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  color: white;\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Gentleman', Arial, sans-serif;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  max-width: 800px;\n  min-width: 200px;\n  width: 100%;\n  @media screen and (max-width: 420px) {\n    font-size: 15px;\n  }\n  ", "\n"])), function (_ref19) {
  var $bsStyle = _ref19.$bsStyle;
  return $bsStyle || '';
});
exports.PreformattedText = PreformattedText;
var List = _styledComponents.default.ul(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0 10px 0 20px;\n  margin-top: 0;\n  li {\n    margin: 0 0 0.5em 0;\n    &:before {\n      content: '\\2022';\n      color: #ff9c33;\n      font-weight: bold;\n      display: inline-block;\n      width: 1em;\n      margin-left: -1em;\n    }\n    a {\n      font-size: 17px;\n      color: #1d2526;\n      &:hover {\n        color: #ff9c33;\n      }\n    }\n  }\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n  ", "\n"], ["\n  list-style: none;\n  padding: 0 10px 0 20px;\n  margin-top: 0;\n  li {\n    margin: 0 0 0.5em 0;\n    &:before {\n      content: '\\\\2022';\n      color: #ff9c33;\n      font-weight: bold;\n      display: inline-block;\n      width: 1em;\n      margin-left: -1em;\n    }\n    a {\n      font-size: 17px;\n      color: #1d2526;\n      &:hover {\n        color: #ff9c33;\n      }\n    }\n  }\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n  ", "\n"])), function (_ref20) {
  var $bsStyle = _ref20.$bsStyle;
  return $bsStyle || '';
});
exports.List = List;
var Title = _styledComponents.default.h4(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  letter-spacing: 0.09px;\n  color: white;\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-weight: 800;\n  font-family: 'Gentleman', Arial, sans-serif;\n  @media screen and (max-width: 420px) {\n    font-size: 14px;\n  }\n  ", "\n"])), function (_ref21) {
  var $bsStyle = _ref21.$bsStyle;
  return $bsStyle || '';
});
exports.Title = Title;
var TitleWithEmoji = _styledComponents.default.h4(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  letter-spacing: 0.09px;\n  color: white;\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-family: 'Gentleman', Arial, sans-serif;\n  @media screen and (max-width: 420px) {\n    font-size: 14px;\n  }\n  ", "\n"])), function (_ref22) {
  var $bsStyle = _ref22.$bsStyle;
  return $bsStyle || '';
});
exports.TitleWithEmoji = TitleWithEmoji;
var TitleSpan = _styledComponents.default.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-weight: 800;\n"])));
exports.TitleSpan = TitleSpan;